import React from 'react';
import PropTypes from 'prop-types';
import { Col, Form, FormGroup, Label, Row } from 'reactstrap';
import { Field, reduxForm } from 'redux-form';

import FormItem from '../../../common/forms/FormItem';
import TextInput from '../../../common/forms/input/TextInput';
import FormFooter from '../../../common/forms/FormFooter';

import { isRequired, validateEndDate } from '../../../../utils/validators';
import PreventiveTaskProjectionAreaViewField from '../preventive-task-projection/PreventiveTaskProjectionAreaViewField';
import PreventiveTaskProjectionDepartmentViewField from '../preventive-task-projection/PreventiveTaskProjectionDepartmentViewField';

const validateDate = (value, allValues) =>
  validateEndDate(value, allValues.dateFrom);

const PreventiveTaskExecutionHistorySearchForm = ({
  handleSubmit,
  loading,
}) => (
  <Form onSubmit={handleSubmit}>
    <FormGroup row>
      <FormItem label="Fechas" required>
        <Row>
          <Col md="6">
            <Field
              name="dateFrom"
              component={TextInput}
              type="date"
              validate={[isRequired]}
              placeholder="Fecha inicial"
              showToolTip
            />
          </Col>

          <Col md="6">
            <Field
              name="dateTo"
              component={TextInput}
              type="date"
              validate={[isRequired, validateDate]}
              placeholder="Fecha final"
              showToolTip
            />
          </Col>
        </Row>
      </FormItem>
    </FormGroup>

    <FormGroup row>
      <FormItem label="Vista" required>
        <div>
          <Label className="mr-3">
            <Field name="view" component="input" type="radio" value="USER" />{' '}
            Mis tareas
          </Label>

          <PreventiveTaskProjectionAreaViewField />

          <PreventiveTaskProjectionDepartmentViewField />
        </div>
      </FormItem>
    </FormGroup>

    <FormFooter
      saveButtonColor="secondary"
      saveButtonDisabled={loading}
      saveButtonIcon={loading ? 'fa fa-spinner fa-spin' : 'fa fa-search'}
      saveButtonText={loading ? 'Cargando...' : 'Buscar'}
      saveButtonType="submit"
    />
  </Form>
);

PreventiveTaskExecutionHistorySearchForm.propTypes = {
  handleSubmit: PropTypes.func.isRequired,
  loading: PropTypes.bool,
};

PreventiveTaskExecutionHistorySearchForm.defaultProps = {
  loading: false,
};

export default reduxForm({
  form: 'PreventiveTaskExecutionHistorySearchForm',
  enableReinitialize: false,
})(PreventiveTaskExecutionHistorySearchForm);
